var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-amazon",on:{"click":_vm.onClick}},[_c('img',{staticClass:"image",attrs:{"src":require("../../../../../assets/images/sns/btnLWA_gold_312x64.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }